import 'chart.js/auto';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { watchAppUpdates } from './app-update';

if (environment.production) {
  enableProdMode(); 
}


watchAppUpdates(environment.production);
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));  
